import { render, staticRenderFns } from "./OsobaStavkaBase.vue?vue&type=template&id=b3a5ccfc&scoped=true&"
import script from "./OsobaStavkaBase.vue?vue&type=script&lang=js&"
export * from "./OsobaStavkaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a5ccfc",
  null
  
)

export default component.exports